require('./vsko-pagination.css');

var vskoPagination = angular.module('vskoPagination', ['ui.bootstrap']);

vskoPagination.constant('vskoPaginationConfig', {
  itemsPerPage: 30,
  boundaryLinks: true,
  boundaryLinkNumbers: true,
  directionLinks: true,
  firstText: '<<',
  previousText: '<',
  nextText: '>',
  lastText: '>>',
  rotate: true,
  maxSize: 4,
  forceEllipses: false
});

vskoPagination.controller('vskoPaginationCtrl', ['$scope', 'vskoPaginationConfig', function($scope, vskoPaginationConfig){
   if (angular.isDefined($scope.vskoPaginationOptions)) {
     $scope.options = $scope.$eval($scope.vskoPaginationOptions);
   }
   $scope.options = angular.extend({}, vskoPaginationConfig, $scope.options);

   $scope.$watch('ngModel', function(newValue, oldValue) {
     if (angular.isDefined($scope.ngChange) && newValue != oldValue) {
        $scope.ngChange();
     }
   });
}]);

vskoPagination.directive('vskoPagination', function () {
  return {
    restrict: 'E',
    controller: 'vskoPaginationCtrl',
    controllerAs: 'vm',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      ngChange: '&?',
      totalItems: '=',
      numPages: '=?',
      vskoPaginationOptions: '@?'
    },
    template: require('./vsko-pagination.html'),
  }
});

vskoPagination.constant('vskoPagerConfig', {
  itemsPerPage: 10,
  previousText: '<',
  nextText: '>',
  align: true
})

vskoPagination.controller('vskoPagerCtrl', ['$scope', 'vskoPagerConfig', function($scope, vskoPagerConfig){
   if (angular.isDefined($scope.vskoPagerOptions)) {
     $scope.options = $scope.$eval($scope.vskoPagerOptions);
   }

   $scope.options = angular.extend({}, vskoPagerConfig, $scope.options);

   $scope.$watch('ngModel', function(newValue, oldValue) {
     if (angular.isDefined($scope.ngChange) && newValue != oldValue) {
        $scope.ngChange();
     }
   });
}]);

vskoPagination.directive('vskoPager', function () {
  return {
    restrict: 'E',
    controller: 'vskoPagerCtrl',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      ngChange: '&?',
      totalItems: '=?',
      numPages: '=?',
      vskoPagerOptions: '@?'
    },
    template: require('./vsko-pager.html'),
  };
});
